var UitkMoreInfoTriggerSizesArray = ['small', 'medium', 'large'];
var UitkMoreInfoTriggerWeightsArray = ['regular', 'bold'];
var UitkMoreInfoTriggerAlignsArray = ['leading', 'center', 'trailing'];
var UitkMoreInfoTriggerThemesArray = ['default', 'emphasis', 'positive', 'negative', 'inverse'];
export { UitkMoreInfoTriggerAlignsArray, UitkMoreInfoTriggerSizesArray, UitkMoreInfoTriggerThemesArray, UitkMoreInfoTriggerWeightsArray };